module.exports = __webpack_public_path__ + "img/marketing.f9b004a8.png";